import React, { useState } from 'react'
import { Button } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

export default function LimitedFieldDisplay({ values }) {
  const [t] = useTranslation()
  const [showMore, setShowMore] = useState()

  return (
    <>
      <span>
        {values[0].displayLabel}: {values[0].value}
      </span>
      {!showMore && values.length > 1 && <br />}
      {!showMore && values.length > 1 && (
        <Button
          linkName="See More"
          data-testid="see-more-button"
          onClick={() => {
            setShowMore(true)
          }}
        >
          {t('family-review.field.display.toggleInfo.more', 'See More')}
        </Button>
      )}
      {showMore &&
        values.map(
          ({ displayLabel, value, id }, index) =>
            value &&
            displayLabel &&
            displayLabel !== '<Unknown Type>' && (
              <span key={id}>
                {index !== 0 && (
                  <>
                    {displayLabel}: {value}
                  </>
                )}
                <br />
              </span>
            )
        )}
      {showMore && values.length > 1 && (
        <Button
          linkName="See Less"
          data-testid="see-less-button"
          onClick={() => {
            setShowMore(false)
          }}
        >
          {t('family-review.field.display.toggleInfo.less', 'See Less')}
        </Button>
      )}
    </>
  )
}
